export const CANCEL = 'CANCEL_PROFILE_CHANGES'
